import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled, { css } from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"

interface IProps {
  partners: {
    image: any
  }[]
  hiddenMobile: boolean
}

const Wrapper = styled.div<{ $hiddenMobile?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  padding: 20px 0;
  max-width: 1100px;
  margin: 0 auto;
  justify-content: center;


  ${props => props.$hiddenMobile && css`
    @media (max-width: 680px) {
      display: none;
    }
  `}
`

const Partners = (props: IProps) => (
  <Wrapper $hiddenMobile={props.hiddenMobile}>
    {props.partners.map(
      (p, i) =>
        p.image && (
          <GatsbyImage
            key={i}
            image={getGatsbyImage(p.image.localFile)}
            alt={`Partner ${i}`}
          />
        )
    )}
  </Wrapper>
)

export default Partners
